export default "__VITE_ASSET__DWUjFDfj__"